import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/admin/PageHeader";
import { DonationList } from "@/components/admin/DonationList";
import { DonationRecap } from "@/components/admin/DonationRecap";
import { DonationSettings } from "@/components/admin/DonationSettings";

export default function Donasi() {
  const [version, setVersion] = useState(0);
  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  const [tab, setTab] = useState("list");

  useEffect(() => {}, [version]);

  return (
    <div data-testid="admin-donation-page">
      <PageHeader title="Donasi" subtitle="Konfirmasi donasi masuk, rekap, dan pengaturan pembayaran" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="rounded-full bg-white border border-emerald-900/10 p-1 h-auto">
          <TabsTrigger value="list" className="rounded-full data-[state=active]:emerald-bg data-[state=active]:bg-[#0d3b2e] data-[state=active]:text-white" data-testid="donation-tab-list">Daftar Donasi</TabsTrigger>
          <TabsTrigger value="recap" className="rounded-full data-[state=active]:bg-[#0d3b2e] data-[state=active]:text-white" data-testid="donation-tab-recap">Rekap</TabsTrigger>
          <TabsTrigger value="settings" className="rounded-full data-[state=active]:bg-[#0d3b2e] data-[state=active]:text-white" data-testid="donation-tab-settings">Pengaturan</TabsTrigger>
        </TabsList>
        <TabsContent value="list" className="mt-6"><DonationList onChanged={refresh} /></TabsContent>
        <TabsContent value="recap" className="mt-6"><DonationRecap version={version} /></TabsContent>
        <TabsContent value="settings" className="mt-6"><DonationSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
